/* eslint-disable no-restricted-syntax */
const axios = require('axios');


function filter(input) {
  // const form = document.querySelector('#filter');
  // const { page } = form.dataset;
  // const innerProduct = document.querySelector('.allproducts');
  // innerProduct.innerHTML = `<p class='waait'>لطفاً کمی منتظر باشید.....</p>`;
  // // const { brand, pressureOne, pressure } = input.dataset;
  // const allinputs = document.querySelectorAll('input');

  // function getChecked() {
  //   const checked = [];

  //   for (let i = 0; i < allinputs.length; i++) {
  //     const checkbox = allinputs[i];
  //     if (checkbox.checked) checked.push(checkbox.value);
  //   }
  //   return checked;
  // }

  // axios
  //   .get('/api/filter', {
  //     params: {
  //       page: `${page}`,
  //       brand: `${input.value}`,
  //       // pressureOne: `${pressureOne}`,
  //       // pressureTwo: `${pressureTwo}`,
  //       // tempOne: `${tempOne}`,
  //       // tempTwo: `${tempTwo}`,
  //       // material: `${material}`,
  //       // sayyal: `${sayyal}`,
  //       // connection: `${connection}`,
  //       // explosion: `${explosion}`,
  //     },
  //   })
  //   .then((response) => {
  //     // loop via all products in the related subcat
  //     for (let i = 0; i < response.data.productsForSubCat.length; i++) {
  //       const checked = getChecked();
  //       const product = response.data.productsForSubCat[i];
  //       const filterObj = { ...checked };
  //       product.filter.filter(function (item) {
  //         // eslint-disable-next-line no-restricted-syntax
  //         // eslint-disable-next-line guard-for-in
  //         return console.log(item.feature.includes(filterObj));
  //         //  return console.log(product);
  //       });
  //     }
  //     console.log(response);
  //   });
}

// function (key) {

//   // return input.checked && key.feature.includes(input.value)
//   //   ? console.log(product)
//   //   : inputs.forEach((inp) => inp.checked === true)
//   //     ? console.log(product)
//   //     : console.log('محصولی یافت نشد.');
// }

export default filter;



// WEBPACK FOOTER //
// ./public/javascripts/modules/filter.js